module.exports = __webpack_public_path__ + "img/anniversary.542d9e2e.png";